import classNames from 'classnames'

import { type TMainCategoryData } from '@/app/types/servicesTypes'
import { Button, Divider, Modal } from '@/shared'

import style from './RemoveSectionModal.module.scss'

interface IAction {
    title: 'Удалить' | 'Отменить'
    color: 'blue' | 'red'
    disabled: boolean
    callback: () => void
}

interface IProps {
    removableSection: TMainCategoryData
    onClose: () => void
    onRemoveSection: (id: string, onSuccess: () => void) => void
}

export const RemoveSectionModal = (props: IProps) => {
    const { removableSection, onClose, onRemoveSection } = props

    const onCancelRemovementCallback = () => {
        onClose()
    }

    const onRemoveSectionCallback = () => {
        onRemoveSection(removableSection.id, onCancelRemovementCallback)
        onCancelRemovementCallback()
    }

    const actions: IAction[] = [
        { title: 'Удалить', color: 'blue', disabled: false, callback: onRemoveSectionCallback },
        { title: 'Отменить', color: 'red', disabled: false, callback: onCancelRemovementCallback }
    ]

    const warningRemove = `Раздел "${removableSection.name}" будет безвозвратно удален и все имеющиеся услуги внутри него будут перенесены в категорию "Иные услуги". \nЗаранее убедитесь, что нет услуг которые должны быть отображены клиенту.`

    return (
        <Modal show={!!removableSection} onClose={onCancelRemovementCallback}>
            <div className={style.container}>
                <div className={style.header}>
                    <span>Удалить Раздел</span>
                </div>
                <div className={style.content}>
                    <span>{warningRemove}</span>
                </div>
                <Divider />
                <div className={style.actions}>
                    {actions.map((action) => {
                        const { title, color, disabled, callback } = action
                        return (
                            <Button
                                key={title}
                                className={classNames(style.btn, style[color])}
                                onClick={callback}
                                disabled={disabled}
                            >
                                {title}
                            </Button>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}
